<script>
import { BaseStoryCardElementMixin } from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import { mapState } from "pinia";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import ActionCountElement
  from "%/dynamic-component-editor/standard-elements/action-element/ActionCountElement.vue";
import DisplayValue from "%/dynamic-component-editor/options/display-value";
import { countToShow, isCountShown } from "%/dynamic-component-editor/helpers/story-engagement.mjs";
import HideCountAtZero from "%/dynamic-component-editor/options/hide-count-at-zero";
import ButtonActionCountOptions from "%/dynamic-component-editor/bundles/button-action-count-options";
import { ENGAGEMENT_ICONS } from "%/dynamic-component-editor/standard-elements/action-element/engagement-action-mixin";
import { ELEMENT_PANEL_FOLDER } from "%/dynamic-component-editor/constants/element-panel-folder-names";

export default {
  name: "LikeCount",
  elementPanelSettings: {
    folder: ELEMENT_PANEL_FOLDER.COUNTS_AND_SCORES,
    displayName: "Like Count",
    displayIcon: "material-symbols:filter-1-outline",
    elementType: "element",
    elementGroup: "storyElements",
  },
  extends: ActionCountElement,
  mixins: [BaseStoryCardElementMixin],
  options: [
    new HideCountAtZero({ default: true }),
  ],
  optionBundles: [
    new ButtonActionCountOptions({ "default.icon": ENGAGEMENT_ICONS.like, "default.display-icon": "hide" }),
  ],
  computed: {
    ...mapState(useConfigurationStore, [
      "canLikePosts",
    ]),
    shouldShowAction() {
      return isCountShown({
        editMode: this.editMode,
        featureOn: this.canLikePosts,
        count: this.entity.likeCount,
        hideAtZero: this.getOptionValue(HideCountAtZero),
      });
    },
    myValue() {
      return countToShow(this.entity.likeCount, this.getOptionValue(DisplayValue));
    },
  },
  methods: {
    handleClick() {
      return;// TODO
    },
  },
};
</script>
